export default "__VITE_ASSET__B7EjoH6H__"